import {
    useCtaAutoOpen,
    useCtaAutoOpenRequest,
    type CtaAutoOpenRequest,
} from '../hooks/use-cta-auto-open';

const CtaAutoOpener = ({ request }: { request: CtaAutoOpenRequest }) => {
    useCtaAutoOpen(request);
    return null;
};

/**
 * Opens the page's Enquire or Book a meeting popup from `?enquire=1` /
 * `?book=1`; see {@link useCtaAutoOpen}. Render once per detail page, inside
 * its `PageCtasProvider`. The opener only mounts when the URL asks for it, so
 * pages without the params carry no extra enquiry hooks.
 */
export const CtaAutoOpen = () => {
    const request = useCtaAutoOpenRequest();
    return request ? <CtaAutoOpener request={request} /> : null;
};
